import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';

/**
 * T075: useIdentifierReport hook.
 * Fetches GET /api/identifiers and GET /api/identifiers/products.
 */

interface IdentifierReport {
  totalProducts: number;
  validGtins: number;
  invalidGtins: number;
  missingGtins: number;
  withSku: number;
  withMpn: number;
  coveragePercent: number;
  generatedAt?: string;
}

interface IdentifierProduct {
  id: string;
  title: string;
  shopifyProductId: string;
  barcode: string | null;
  barcodeStatus: string;
  hasSku: boolean;
  hasMpn: boolean;
}

interface PaginatedResult<T> {
  data: T[];
  meta: {
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  };
}

export function useIdentifierReport() {
  return useQuery<IdentifierReport>({
    queryKey: ['identifiers'],
    queryFn: () => api.get<IdentifierReport>('/identifiers'),
    staleTime: 60_000,
  });
}

export function useIdentifierProducts(
  status: 'VALID' | 'INVALID' | 'MISSING',
  page = 1,
  limit = 20,
) {
  return useQuery<PaginatedResult<IdentifierProduct>>({
    queryKey: ['identifiers', 'products', status, page, limit],
    queryFn: () =>
      api.get<PaginatedResult<IdentifierProduct>>(
        `/identifiers/products?status=${status}&page=${page}&limit=${limit}`,
      ),
    staleTime: 30_000,
  });
}
